const getEmailFromLocalStorage = () => {
  const email = localStorage.getItem('anova_email')

  return email
}

export default getEmailFromLocalStorage
